(function (ws) {
    'use strict';

    ws.views.quickLinks = ws.views.baseWidget.extend({
        GTM_EVENT_CATEGORY: 'store_dashboard',
        GTM_EVENT_ACTION: 'click_quick_link',

        events: {
            'click a': 'trackLink'
        },

        /**
         * Initializes the component.
         */
        initialize() {
            ws.views.baseWidget.prototype.initialize.call(this);
            this.render();
        },

        /**
         * Render
         */
        render: function () {
            this.$('a, .description').dotdotdot({
                tolerance: 5,
                wrap: 'letter',
                callback: () => {
                    this.reveal();
                    var $truncatedEl = this.$('.is-truncated');
                    if ($truncatedEl && $truncatedEl.length > 0 && $truncatedEl.data('processed') !== true) {
                        var height = $truncatedEl.css('max-height');
                        $truncatedEl.css('max-height', 'none');
                        var newHeight = $truncatedEl.css('height');

                        if (height !== 'none' && newHeight > height) {
                            var text = $truncatedEl.text().trim();
                            text = text.replace(/\W*\s(\S)*$/, '...');
                            $truncatedEl.text(text);
                        }

                        $truncatedEl.css('max-height', height);
                        $truncatedEl.removeClass('is-truncated');
                        $truncatedEl.attr('data-processed', true);
                    }
                }
            });
        },

        /**
         * Reveals the widget after the dotdotdot library processes its texts.
         */
        reveal() {
            this.$('dl').css('visibility', 'visible');
        },

        /**
         * Sends data from a link to Google Analytics;
         * this.GTM_EVENT_LABEL must be defined in an extended class.
         *
         * @param {Event} e
         */
        trackLink: function (e) {
            const url = $(e.currentTarget).attr('href');

            // Stop the link from navigating away
            e.preventDefault();

            // Send tracking data to Google Analytics
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION, url);

            // Send tracking data to adobe Analytics
            dataLayerAA.event = {};
            dataLayerAA.event.action = 'quick links';
            dataLayerAA.event.label = e.target.text.toLowerCase();
            _satellite.track('event:dashboard');

            // Navigate away after the tracking is complete
            window.location.href = url;
        }
    });
})(westcon);
